"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isAdminGW;

function isAdminGW() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /\/v1\/gw\//.test(api) || /\/v1\/jsonp\/gw\//.test(api);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9taXNlcy9pc0FkbWluR1cudHMiXSwibmFtZXMiOlsiaXNBZG1pbkdXIiwiYXBpIiwidGVzdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFlLFNBQVNBLFNBQVQsR0FBNkI7QUFBQSxNQUFWQyxHQUFVLHVFQUFKLEVBQUk7QUFDeEMsU0FBTyxhQUFhQyxJQUFiLENBQWtCRCxHQUFsQixLQUEwQixvQkFBb0JDLElBQXBCLENBQXlCRCxHQUF6QixDQUFqQztBQUNIIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gaXNBZG1pbkdXKGFwaSA9ICcnKSB7XG4gICAgcmV0dXJuIC9cXC92MVxcL2d3XFwvLy50ZXN0KGFwaSkgfHwgL1xcL3YxXFwvanNvbnBcXC9nd1xcLy8udGVzdChhcGkpO1xufVxuIl19